import { ErrorMessages } from '../types/common/Messages';

// 文字列チェック用のモジュール

// 入力長チェック
export const checkLength = (input: string, inputName: string, checkLength: number) => {
    if (input.length > checkLength) {
        return ErrorMessages.CI_VAL04.replace('%1', inputName).replace('%2', checkLength.toString());
    }

    return '';
};

// 電話番号形式チェック
export const checkPhoneFormat = (phoneNumber: string) => {
    if (!/^0\d{1,4}-\d{1,4}-\d{3,4}$/.test(phoneNumber)) {
        return false;
    }
    return true;
};

// メールアドレス形式チェック
export const checkMailAddressFormat = (mailAddress: string) => {
    if (
        !/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
            mailAddress ?? ''
        )
    ) {
        return false;
    }
    return true;
};
